import { render, staticRenderFns } from "./DetalhesDevolucao.vue?vue&type=template&id=c8363c5e&scoped=true&"
import script from "./DetalhesDevolucao.vue?vue&type=script&lang=js&"
export * from "./DetalhesDevolucao.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesDevolucao.vue?vue&type=style&index=0&id=c8363c5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8363c5e",
  null
  
)

export default component.exports